import ApiClient from './ApiClient';

class CallLogAPI extends ApiClient {
  constructor() {
    super('calls', { accountScoped: true });
  }

  outgoing(data) {
    return axios.post(`${this.url}/outgoing`, data);
  }
}

export default new CallLogAPI();
